import React from 'react';
import { Col } from 'antd';
import type { ColProps as AntColProps } from 'antd';
import type { BaseComponentProps } from '../../types/common';

export interface AndColumnProps extends AntColProps, BaseComponentProps {}

export const AndColumn: React.FC<AndColumnProps> = ({
  id, sessionId, develop, children, ...restProps
}) => {
  return <Col {...restProps}>{children}</Col>;
};

export default AndColumn;
